import { render, staticRenderFns } from "./SendCodeModal.vue?vue&type=template&id=1debb5f8&scoped=true"
import script from "./SendCodeModal.vue?vue&type=script&lang=js"
export * from "./SendCodeModal.vue?vue&type=script&lang=js"
import style0 from "./SendCodeModal.vue?vue&type=style&index=0&id=1debb5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1debb5f8",
  null
  
)

export default component.exports